// Import made to reuse web media manager code and overwrite the tizen specific logic
import { default as mediaManager } from "../../../web/manager/media/media";

export const media = {
  ...mediaManager
};
